import React from 'react';

import {EmailWarning} from 'features/profile';

import {MainLayout} from 'widgets/layout';

const EmailWarningPage: React.FC = () => {
    return <MainLayout isPlugMode>
        <EmailWarning />
    </MainLayout>;
};

export default EmailWarningPage;